import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types";
import { TGlobalSearchProviderContext } from "./provider.types";

export const createCalendariosProvider = (ctx: TGlobalSearchProviderContext): ISearchProvider => {
    return {
        key: "calendarios",
        label: "Calendarios",
        subLabel: "Gestión de calendarios (eventos escolares, grupales y menús de alimentos)",
        action: ctx.navigateModule("escuelas/calendarios"),
        search: (): ISearchResult[] => ([])
    };
};